import { combineReducers } from 'redux';
// Front
import LayoutReducer from './layouts/reducer';
// Authentication
import LoginReducer from './auth/login/reducer';
import RoleReducer from './auth/role/reducer';

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  SelectedRole: RoleReducer
});

export default rootReducer;
